import Page from "@app/components/pageTypes/Page/Page"
import AnimatedRoute from "@app/components/routing/AnimatedRoute/AnimatedRoute"
import Zone from "@app/components/zone/Zone/Zone"
import { resetOrderState } from "@app/store/actions/orderActions"
import { useGetStrings, useGetZones } from "@app/store/service/cmsService"
import { emptyArray } from "@app/utils/objectUtils"
import { useEffect } from "react"
import Skeleton from "react-loading-skeleton"
import "./ZoneSelectionPage.css"

export default function ZoneSelectionPage() {
	const { data: zones, isLoading } = useGetZones()
	const {
		data: { zoneSelectionTitle, zoneSelectionSubTitle },
	} = useGetStrings(undefined, { defaultData: {} })
	//If we open the default home page we reset the orderState, so that we don't have any invalid data anymore
	useEffect(() => {
		setTimeout(() => {
			resetOrderState()
		}, 300)
	}, [])

	return (
		<>
			<AnimatedRoute className="h-100">
				<Page className="p-4 zoneSelection scrollable">
					<div className="f-second text-center color-fg-primary">
						<h1 className="f1">{zoneSelectionTitle ? zoneSelectionTitle : <Skeleton />}</h1>
						<h2 className="f3 mt-1">{zoneSelectionSubTitle ? zoneSelectionSubTitle : <Skeleton />}</h2>
					</div>
					<div className="flex flex-column flex-lg-row flex-justify-center mt-4 zones">
						{isLoading &&
							emptyArray(3).map((e, i) => {
								return <Zone key={i} />
							})}
						{zones && zones.map((e, i) => <Zone key={i} zoneId={e.zoneId} />)}
					</div>
				</Page>
			</AnimatedRoute>
		</>
	)
}
